export type TreatProduct = {
  id: string | number;
  title: string;
  handle: string;
  image: string;
  grams: number;
  price: string;
  variantId: string | number;
  variant: any;
};

export type TreatProductsResult = {
  products: TreatProduct[];
  error?: string;
};

export async function getTreatProducts(): Promise<TreatProductsResult> {
  try {
    const res = await fetch(`/collections/nanas-nibbles/products.json?limit=250`);

    if (!res.ok) {
      console.error("[getTreatProducts] API error:", res.status);
      return { products: [], error: "Failed to load treats" };
    }

    const data = await res.json();

    const products: TreatProduct[] = (data.products ?? [])
      .map((p: any) => {
        const firstAvailable = (p.variants ?? []).find((v: any) => v.available);
        if (!firstAvailable) return null;

        return {
          id: p.id,
          title: p.title,
          handle: p.handle,
          image: p.images?.[0]?.src ?? "",
          grams: parseInt(firstAvailable.title?.replace(/\D/g, "") ?? "0") || 0,
          price: firstAvailable.price,
          variantId: firstAvailable.id,
          variant: firstAvailable,
        };
      })
      .filter((p: TreatProduct | null): p is TreatProduct => p !== null);

    return { products };
  } catch (e) {
    console.error("[getTreatProducts] Network error:", e);
    return { products: [], error: "Network error loading treats" };
  }
}
